import { useState } from "react";
import { HelpCircle, Upload, Mic, Wand2, Scissors, Download, CheckSquare } from "lucide-react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";

const STEPS = [
  {
    icon: Upload, color: "#FF2E93", title: "1. Importe os brutos",
    text: "Envie os vídeos do computador (botão rosa) ou importe direto do Google Drive. Cada arquivo vira um card na Biblioteca.",
  },
  {
    icon: CheckSquare, color: "#10B981", title: "2. Selecione os vídeos do episódio",
    text: "Marque vários vídeos na Biblioteca e clique em \"Montar episódio com IA\". A IA transcreve tudo automaticamente e cruza o material dos vídeos selecionados.",
  },
  {
    icon: Wand2, color: "#00E5FF", title: "3. A IA roteiriza",
    text: "Ela escolhe os melhores momentos (treta, DR, clímax...), sugere a ordem das cenas e escreve teaser + narrações no tom do programa.",
  },
  {
    icon: Mic, color: "#8B5CF6", title: "4. Revise a prévia e edite",
    text: "Assista cada momento no player, edite títulos e narrações, reordene ou exclua cenas e aprove o roteiro final.",
  },
  {
    icon: Scissors, color: "#F59E0B", title: "5. Exporte",
    text: "Gere o Rough Cut do episódio (corte automático), a narração em voz IA, cortes verticais 9:16 e a EDL para finalizar no Premiere/DaVinci.",
  },
];

export const HowItWorks = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button onClick={() => setOpen(true)} data-testid="how-it-works-button"
        className="bg-transparent border border-[#282834] hover:border-[#00E5FF] text-[#A1A1AA] hover:text-[#F4F4F5] rounded-full px-4 py-2.5 flex items-center gap-2 text-sm transition-colors duration-200">
        <HelpCircle className="w-4 h-4 text-[#00E5FF]" /> Como funciona
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#121218] border-[#282834] text-[#F4F4F5] max-w-lg" data-testid="how-it-works-dialog">
          <DialogHeader>
            <DialogTitle className="font-head text-xl">Como funciona o Reality Editor</DialogTitle>
            <DialogDescription className="text-[#A1A1AA]">
              Do bruto ao episódio pronto em 5 passos.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 mt-2">
            {STEPS.map((s) => (
              <div key={s.title} className="flex gap-3">
                <span className="w-9 h-9 rounded-lg shrink-0 flex items-center justify-center" style={{ background: s.color + "1a" }}>
                  <s.icon className="w-4.5 h-4.5 w-[18px] h-[18px]" style={{ color: s.color }} />
                </span>
                <div>
                  <p className="text-sm font-semibold">{s.title}</p>
                  <p className="text-xs text-[#A1A1AA] leading-relaxed mt-0.5">{s.text}</p>
                </div>
              </div>
            ))}
          </div>
          <p className="text-[11px] text-[#555] mt-2 flex items-center gap-1.5">
            <Download className="w-3 h-3" /> Todas as entregas ficam disponíveis para download dentro do editor de cada episódio/vídeo.
          </p>
        </DialogContent>
      </Dialog>
    </>
  );
};
